import React from 'react';

import './react-reddit-crossposter.scss';

/* eslint-disable-next-line */
export interface ReactRedditCrossposterProps {}

export const ReactRedditCrossposter = (props: ReactRedditCrossposterProps) => {
  return (
    <div>
      <h1>Welcome to react-reddit-crossposter component!</h1>
    </div>
  );
};

export default ReactRedditCrossposter;
